import InnerContainer, {
  InnerPaddingWrapper,
} from "components/atoms/inner/InnerContainer";
import styled from "styled-components";
import { COLORS, LEVELS } from "../../../styles/colors";
import { FLEX } from "../../../styles/flex";
import { calcRem } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";
import {
  collapsedSidebarWidth,
  discollapsedSidebarWidth,
} from "../sidenav/SideNavBarStyled";

export const HEADER_HEIGHT = 50;
export const HeaderContainer = styled(InnerPaddingWrapper)<{
  level?: string;
  isCollapsed?: boolean;
  noticeHeight: number;
}>`
  height: ${HEADER_HEIGHT}px;
  background-color: ${(props) =>
    props.level
      ? props.level === "EU"
        ? props.theme.COLORS.HEADERBG
        : LEVELS[props.level]
      : props.theme.COLORS.HEADERBG};
  position: fixed;
  top: ${(props) => `${props.noticeHeight}px`};
  right: 0;
  z-index: 900;
  transition: width 300ms linear;
  width: ${(props) =>
    `calc(100% - ${
      !props.isCollapsed
        ? `${collapsedSidebarWidth}px`
        : `${discollapsedSidebarWidth}px`
    })`};

  ${(props) =>
    props.theme.value === "light" &&
    `
  border-bottom: 1px solid ${props.theme.COLORS.LIGHTGRAYBORDER};
  
  `}

  ${mediaQuery.isMobile} {
    ${FLEX.FlexCenterCenter};
    flex: 1;
    z-index: 955;
    width: 100%;
  }

  .sidebar-collapse-button {
    color: ${(props) =>
      props.level === "EU" ? props.theme.COLORS.WHITE : COLORS.WHITE};
    ${FLEX.FlexStartCenter};
  }
`;

export const Inner = styled(InnerContainer)`
  height: 100%;
  gap: 80px;
  ${FLEX.FlexBetweenCenter};
  padding-top: 0;
  overflow: visible;
  ${mediaQuery.isTablet} {
    gap: 20px;
  }
  ${mediaQuery.isMobile} {
    gap: 14px;
    overflow: visible;
    > button {
      > img {
        height: 15px;
      }
    }
  }
`;

export const MenuInnerContainer = styled.div`
  width: fit-content;
  min-width: 100%;
`;

export const LeftWrapper = styled.div`
  height: 100%;
  flex: 1;
  min-width: 0;
  ${mediaQuery.isDefault} {
    ${FLEX.FlexStartCenter};
    gap: 80px;
  }
  ${mediaQuery.isTablet} {
    gap: 20px;
  }

  ${mediaQuery.isMobile} {
    width: calc(100% - 100px);
    flex: 1;
    ${FLEX.FlexStartCenter};
    gap: 20px;
    position: relative;

    .left-slide-button {
      left: -5px;
      z-index: 99;
    }
    .right-slide-button {
      right: 0;
    }
  }
`;

export const Title = styled.h2<{ level?: string }>`
  color: ${({ theme }) => COLORS.WHITE};
  color: ${(props) => props.level === "EU" && props.theme.COLORS.WHITE};
  /* color: ${(props) => props.theme.COLORS.WHITE}; */
  font-weight: 500;
  font-size: ${calcRem(24)};
  cursor: pointer;
  white-space: nowrap;
`;

export const MenuContainer = styled.nav`
  height: 100%;
  overflow: hidden;
  flex: 1;
  min-width: 0;
  white-space: nowrap;

  ${mediaQuery.isMobile} {
    padding-right: 20px;
    overflow-x: auto;
    box-sizing: border-box;
    position: relative;

    ::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const MenuItem = styled.button<{
  isCurrent: boolean;
  level?: string;
  isHidden?: boolean;
  isOpen?: boolean;
}>`
  height: 100%;
  font-size: ${calcRem(15)};
  padding: 6px 10px 0;
  ${FLEX.FlexCenterCenter};
  display: inline-flex;
  height: ${HEADER_HEIGHT}px;
  ${(props) => props.isHidden && "visibility: hidden;"}
  ${(props) => {
    if (props.isCurrent) {
      return `
        color: ${
          props.level === "EU" ? props.theme.COLORS.WHITE : COLORS.WHITE
        };
        border-bottom: 6px solid ${
          props.isHidden === false
            ? "transparent"
            : props.level === "EU"
            ? props.theme.COLORS.WHITE
            : COLORS.WHITE
        };`;
    }
    if (props.isOpen) {
      return `
        border-bottom: 6px solid transparent;
        color: ${
          props.level === "EU" ? props.theme.COLORS.WHITE : COLORS.WHITE
        };`;
    }
    return `
        border-bottom: 6px solid transparent;
        color: ${
          props.level === "EU" ? props.theme.COLORS.WHITE : COLORS.WHITE
        }90;
      `;
  }}
  svg {
    width: 12px;
    height: 12px;
    margin-left: 10px;
    opacity: 0.9;
    ${mediaQuery.isMobile} {
      margin-left: 4px;
      transform: scale(0.7);
    }
  }
  path {
    fill: currentColor !important;
  }
`;

export const MapButton = styled.div`
  ${mediaQuery.isDefault} {
    margin-left: 20px;
  }
  button {
    padding: 10px;
  }
  button > span {
    font-size: ${calcRem(14)};
  }
`;

export const SlideButton = styled.button`
  position: absolute;

  /* cursor: pointer; */
`;

export const RightContainer = styled.div`
  ${FLEX.FlexEndCenter};
  gap: 20px;
  flex-shrink: 0;
`;
